import React, { Component } from "react"

import {
  HeadingInitial,
  HeadingSecondary,
  Paragraph,
  Section,
  List,
  ListItem,
  Tagline,
} from "elements"

class HowToFind extends Component {
  render() {
    return (
      <div>
        <HeadingInitial>How Do We Find a Summer Camp?</HeadingInitial>

        <Section>
          <Paragraph>
            First, you register with Camps and Campers. Registration is quick
            and easy. You will be asked to submit your name and some contact
            information and basic criteria about your camp preferences. This
            allows camps to find you and contact you about camp openings that
            are available. The only people who will ever have access to your
            information are legitimate summer camps who have registered with us.
          </Paragraph>

          <Tagline>
            Remember, there is never any cost to you for using Camps and
            Campers, regardless of how often you use it.
          </Tagline>

          <Paragraph>
            You can find great camps two ways. The first is simply by browsing.
            Browsing lets you look through entire categories of camps, such as
            all camps in New England. You can browse all the information that we
            have about each camp in our database.
          </Paragraph>
          <Paragraph>
            The second and more powerful way to find camps is to use our search
            form. Search for camps using the criteria of your choosing. Once you
            find a list of camps that meet your criteria, you can send your
            personal information directly to camps with the click of a button.
          </Paragraph>
          <Paragraph>
            Sometimes, camps can even find you! Camps are able to search for
            campers by their basic information, interest and camp choices. Camps
            may contact families that meet their selected criteria, this way you
            hear from camps that are actively recruiting campers. Since they can
            see your information even before they contact you, you will only
            hear from camps who are genuinely interested in your camper!
          </Paragraph>
          <Paragraph>
            If you are registering as an international family, we suggest you
            contact camps directly as early as possible to arrange any travel or
            visa issues.
          </Paragraph>
        </Section>

        <Section>
          <HeadingSecondary>Two Ways to Find a Camp</HeadingSecondary>

          <List>
            <ListItem>
              Browse all of our categories of camps. We categorize camps into
              dozens of groupings, including locale and expertises.
            </ListItem>
            <ListItem>
              Search our entire collection of camps. We have hundreds of camps
              that can be searched by dozens of attributes, including available
              dates and age group.
            </ListItem>
          </List>
        </Section>
      </div>
    )
  }
}

export default HowToFind



// WEBPACK FOOTER //
// ./src/scenes/About/pages/howToFind.js